var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 174,
    viewBox: "0 0 19 174",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4430_202085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1.73889 168L-1.73888 85H15L15 160.589L7.15397 168H-1.73889Z",
    fill: "url(#paint0_linear_4430_202085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.73889 168L-1.73888 85H-17.301V160.589L-9.455 168H-1.73889Z",
    fill: "url(#paint1_linear_4430_202085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.73889 2L-1.73888 85H15L15 9.41072L7.15397 2L-1.73889 2Z",
    fill: "url(#paint2_linear_4430_202085)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.73889 2L-1.73888 85H-17.301L-17.301 9.41071L-9.45501 2L-1.73889 2Z",
    fill: "url(#paint3_linear_4430_202085)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4430_202085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9312 162.812C8.30374 159.561 7.05275 160.806 10.4253 157.555L10.4253 117.245",
    stroke: "#D3F5EE",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4430_202085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9312 7.1875C8.30374 10.4385 7.05275 9.19383 10.4253 12.4449L10.4253 52.7548",
    stroke: "#D3F5EE",
    strokeWidth: 0.733377,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4430_202085",
    x: -21.301,
    y: 0,
    width: 40.301,
    height: 174,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.917647 0 0 0 0 0.807843 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_202085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_202085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4430_202085",
    x: 2.60878,
    y: 114.923,
    width: 10.1389,
    height: 50.2111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.917647 0 0 0 0 0.807843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_202085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_202085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4430_202085",
    x: 2.60878,
    y: 4.86562,
    width: 10.1389,
    height: 50.2111,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.977836
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.372549 0 0 0 0 0.917647 0 0 0 0 0.807843 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4430_202085"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4430_202085",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4430_202085",
    x1: -1.73851,
    y1: 43.5,
    x2: -17.3006,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00041B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4430_202085",
    x1: -1.73851,
    y1: 43.5,
    x2: -17.3006,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00041B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4430_202085",
    x1: -1.73851,
    y1: 43.5,
    x2: -17.3006,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00041B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4430_202085",
    x1: -1.73851,
    y1: 43.5,
    x2: -17.3006,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#141791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00041B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSide);
export default __webpack_public_path__ + "static/media/side.dc10b2e2dfe647468913b9bb9e5d4bc0.svg";
export { ForwardRef as ReactComponent };